import { callAppropriateCb } from "./callAppropriateCb";
export class Connection {
    constructor(meta, cbHandler, queryBuilder) {
        this.meta = meta;
        this.cbHandler = cbHandler;
        this.queryBuilder = queryBuilder;
    }
    deactivate() {
        this.query = undefined;
    }
    onData(response) {
        callAppropriateCb(this.cbHandler, response);
    }
    onError(error) {
        this.cbHandler.onError(error);
    }
    loadData(params) {
        this.query = this.queryBuilder(params);
    }
}
//# sourceMappingURL=Connection.js.map